export default __webpack_public_path__ + "static/media/vote-inactive.2b1204db.png";